import { Button, Empty, flex } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const SCxContainer = styled.div`
    width: 100%;
    flex: 1;
    height: 100%;
    background: var(--color-white);
    ${flex}
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

interface PageNoAccessProps {
    onGoHome?: () => void
}

export const PageNoAccess: React.FunctionComponent<PageNoAccessProps> = ({ onGoHome }) => {
    const navigate = useNavigate()

    const handleGoHome = useCallback(() => {
        if (onGoHome) {
            onGoHome()
            return
        }
        navigate('/')
    }, [onGoHome, navigate])

    return (
        <SCxContainer>
            <Empty
                styles={{
                    root: {
                        height: 'auto',
                        flex: 0
                    },
                    content: {
                        marginTop: 32
                    }
                }}
                icon={<img src={getAssetUrl('empty', 'not_permission.svg')} alt="无访问权限" />}
                description="没有页面访问权限，请联系管理员"
            />
            <Button type="default" size="lg" onClick={handleGoHome} style={{ marginTop: 16 }}>
                回到主页
            </Button>
        </SCxContainer>
    )
}
